import { useNavigation, usePreventRemove } from "@react-navigation/native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { useTodoSetStatus } from "../../TodoCategory/useTodoSetStatus";
import { TodoEditNewMainPreventDefault_todo$key } from "./__generated__/TodoEditNewMainPreventDefault_todo.graphql";
import { useTodoEditSubmitAlert } from "./useTodoEditSubmitAlert";

export function TodoEditNewMainPreventDefault(props: {
  todo: TodoEditNewMainPreventDefault_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainPreventDefault_todo on Todo {
        id
        status
        response {
          __typename
        }
        subTodos {
          status
          __typename
        }
        canChangeStatus
        category {
          title
        }
      }
    `,
    props.todo
  );
  const hasResponse = Boolean(todo.response);
  const hasSubTodos = (todo.subTodos?.length ?? 0) > 0;
  const allSubTodosCompleted =
    todo.subTodos?.every((subTodo) => subTodo.status === "DONE") ?? true;

  const isPendingHandIn =
    todo.status === "PENDING" &&
    todo.canChangeStatus &&
    (hasResponse || hasSubTodos) &&
    allSubTodosCompleted;

  const setRemoteStatus = useTodoSetStatus(todo.id ?? null);
  const navigation = useNavigation();
  const todoSubmitAlert = useTodoEditSubmitAlert();
  usePreventRemove(isPendingHandIn, (e) => {
    todoSubmitAlert({
      title: todo.category?.title ?? "",
      onSubmitLater: () => {
        navigation.dispatch(e.data.action);
      },
      onSubmit: () => {
        navigation.dispatch(e.data.action);
        if (todo.id) {
          setRemoteStatus("DONE");
        }
      },
    });
  });
  return null;
}
